import React, { useState } from "react";
import { useDebounce } from "usehooks-ts";
import { usersAPI } from "../shared/api";
import { useNavigate } from "react-router-dom";
import { TenantUsersView } from "./components/TenantUsersView";

import type { TenantUser } from "../shared/types/models";

export const TenantUsersPage: React.FC = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  function navigateToTenantDetails(tenantUser: TenantUser): void {
    if (tenantUser.tenantAccounts.length > 0) {
      // Prioritize active accounts with tenant IDs
      const activeAccountWithTenant = tenantUser.tenantAccounts.find(
        account => account.isActive && account.tenantId
      );
      
      if (activeAccountWithTenant) {
        navigate(`/tenant/tenants/${activeAccountWithTenant.tenantId}`);
        return;
      }
      
      // Fallback to any account with tenant ID
      const accountWithTenant = tenantUser.tenantAccounts.find(
        account => account.tenantId
      );
      
      if (accountWithTenant) {
        navigate(`/tenant/tenants/${accountWithTenant.tenantId}`);
      }
    }
  }

  const handlePaginatorClick = (page: number): void => {
    setCurrentPage(page);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchTerm(event.target.value);
    setCurrentPage(0); // Reset to first page when searching
  };

  const { data: tenantUsers, isLoading: isLoadingTenantUsers } =
    usersAPI.endpoints.findTenantUsers.useQuery({
      page: currentPage,
      limit: 100,
      search: debouncedSearchTerm
    });

  return (
    <TenantUsersView
      tenantUsers={tenantUsers}
      isLoadingTenantUsers={isLoadingTenantUsers}
      navigateToTenantDetails={navigateToTenantDetails}
      handlePaginatorClick={handlePaginatorClick}
      searchTerm={searchTerm}
      onSearchChange={handleSearchChange}
    />
  );
};

export default TenantUsersPage;